<template>
  <div>
    <div class="block q-mt-sm q-mb-sm">
      <q-btn
        push
        color="secondary"
        :label="showDetails? `Hide Details` : `Show Details`"
        icon="remove red eye"
        @click="showDetails = !showDetails"
      ></q-btn>
    </div>
    <q-card
        v-for="model in serverData"
        :key="model.id"
        class="mdi-card q-ma-md"
        inline style="width: 400px"
      >
        <q-card-media v-if="imageField">
          <grid-cell-image :col="imageField" :value="model[imageField.field]">
            <div
              slot-scope="props"
            >
              <q-parallax :src="props.src" :height="250" :speed="0.2">
                <div slot="loading">Loading...</div>
              </q-parallax>
            </div>
          </grid-cell-image>
          <q-card-title slot="overlay">
            {{ model | shvl(titleFieldPath) }}
            <span slot="subtitle" v-if="subTitleFieldPath">
              {{ model | shvl(subTitleFieldPath) }}
            </span>
            <!--
            <q-btn
              @click="$router.push(`${baseRoute}/edit/${model.id}`)"
              fab
              color="info"
              icon="edit"
              class="absolute"
              style="top: 0; right: 8px; transform: translateY(-70%);"
            />
            --->
          </q-card-title>
        </q-card-media>
        <q-card-title class="title relative-position" v-else>
          <span>
            {{ model | shvl(titleFieldPath) }}
          </span>
        </q-card-title>
        <q-card-main>
          <q-collapsible label="details" :value="showDetails">
            <q-list no-border>
              <q-item
                v-for="column in cardFields"
                :key="column.field"
                class="q-body-1"
              >
                <q-item-side color="primary">
                  {{ column.label }}
                </q-item-side>
                <q-item-main class="text-info" align="left">
                    <component
                      :is="column | componentIs"
                      class="text-info"
                      :column="column"
                      :value="model[column.field]"
                      template="raw"
                      :resource="resource"
                      :row="model"
                      :id="model.id"
                    >
                    </component>
                </q-item-main>
              </q-item>
            </q-list>
          </q-collapsible>
        </q-card-main>
        <q-card-separator/>
        <q-card-actions align="between">
          <q-btn
            @click="$router.push(`${baseRoute}/edit/${model.id}`)"
            color="primary"
            flat
            label="edit"
            icon="edit"
          />
          <q-btn flat small color="negative" icon="delete" @click="handleDelete(model.id)"></q-btn>
        </q-card-actions>
      </q-card>
  </div>
</template>

<script>
export default {
  name: 'card-layout',
  data () {
    return {
      showDetails: false
    }
  },
  props: {
    resource: {
      type: String,
      required: true
    }
  },
  computed: {
    serverData () {
      return this.$store.state[this.resource].records
    },
    subTitleFieldPath () {
      const field = this.columns.find(col => col.hasOwnProperty('subtitle'))
      if (field.relation && field.relation.label) {
        return `${field.field}.${field.relation.label}`
      }
      return field.label
    },
    baseRoute () {
      return this.$store.state[this.resource].clientRoute
    },
    columns () {
      return this.$store.getters[`${this.resource}/columns`]
    },
    titleField () {
      return this.columns.find(col => col.isTitle)
    },
    titleFieldPath () {
      const field = this.titleField
      if (field) {
        if (field.relation && field.relation.label) {
          return `${field.field}.${field.relation.label}`
        }
        return field.field
      }
      return null
    },
    cardFields () {
      return this.$store.getters[`${this.resource}/visibleColumns`]
        .filter(col => {
          return !(col.isTitle || col.subtitle || col.type === 'image' || col.type === 'action')
        })
    },
    imageField () {
      return this.columns.find(col => col.type && col.type === 'image')
    }
  }
}
</script>

<style>
</style>
